module.exports = {
  ColorData: () => {
    return {
      "arquitectonica" : 
        [
          {
            "id": "blanco9016",
            "name" : "Blanco 9016",
            "description" : "RAL: 9016 SRI: 85 SR: 0.72",
            "icon": require('../assets/colors/BlancoRAL9016.webp'),
            "color": "#FFFFFF",
            "decal": "gray",
            "active" : true,
            "interactable" : true
          },
          {
            "id": "blanco9002",
            "name" : "Blanco 9002",
            "description" : "RAL: 9002 SRI: 75 SR: 0.65",
            "icon": require('../assets/colors/Blanco_RAL9002.webp'),
            "color": "#E3D9BD",
            "decal": "gray",
            "active" : true,
            "interactable" : true
          },
          {
            "id": "grisglacial",
            "name" : "Gris Glacial",
            "description" : "SRI: 50",
            "icon": require('../assets/colors/Gris_Glacial.webp'),
            "color": "#949494",
            "decal": "gray",
            "active" : true,
            "interactable" : true
          },
          {
            "id": "gristrafico",
            "name" : "Gris Tráfico",
            "description" : "RAL: 7043",
            "icon": require('../assets/colors/Gris_Trafico.webp'),
            "color": "#484A42",
            "decal": "white",
            "active" : true,
            "interactable" : true
          },
          {
            "id": "negro",
            "name" : "Negro",
            "description" : "SRI: -1.0 SR: 0.04",
            "icon": require('../assets/colors/Negro.webp'),
            "color": "#111111",
            "decal": "white",
            "active" : true,
            "interactable" : true
          },
          {
            "id": "azul",
            "name" : "Azul",
            "description" : "RAL: 5005 SRI: 25 SR: 0.30",
            "icon": require('../assets/colors/Azul.webp'),
            "color": "#001C4F",
            "decal": "white",
            "active" : true,
            "interactable" : true
          },
          {
            "id": "verde",
            "name" : "Verde",
            "description" : "RAL: 6005 SRI: 3 SR: 0.08",
            "icon": require('../assets/colors/Verde.webp'),
            "color": "#00281E",
            "decal": "white",
            "active" : true,
            "interactable" : true
          },
          {
            "id": "rojogranate",
            "name" : "Rojo Granate",
            "description" : "SRI: 34 SR: 0.26",
            "icon": require('../assets/colors/Rojo_Granate.webp'),
            "color": "#641411",
            "decal": "white",
            "active" : true,
            "interactable" : true
          },
          {
            "id": "rojoescarlata",
            "name" : "Rojo Escarlata",
            "description" : "SRI: 36 SR: 0.39",
            "icon": require('../assets/colors/Rojo_Escarlata.webp'),
            "color": "#B10712",
            "decal": "white",
            "active" : true,
            "interactable" : true
          },
          {
            "id": "cafecapuccino",
            "name" : "Café Capuccino",
            "description" : "SRI: 40 SR: 0.4",
            "icon": require('../assets/colors/Cafe_Capuccino.webp'),
            "color": "#B3926F",
            "decal": "gray",
            "active" : true,
            "interactable" : true
          }
        ]
      ,
      "master1000" : 
      [
        {
          "id": "blanco9016",
          "name" : "Blanco 9016",
          "description" : "RAL: 9016 SRI: 85 SR: 0.72",
          "icon": require('../assets/colors/BlancoRAL9016.webp'),
          "color": "#FFFFFF",
          "decal": "gray",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "blanco9002",
          "name" : "Blanco 9002",
          "description" : "RAL: 9002 SRI: 75 SR: 0.65",
          "icon": require('../assets/colors/Blanco_RAL9002.webp'),
          "color": "#E3D9BD",
          "decal": "gray",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "grisglacial",
          "name" : "Gris Glacial",
          "description" : "SRI: 50",
          "icon": require('../assets/colors/Gris_Glacial.webp'),
          "color": "#949494",
          "decal": "gray",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "gristrafico",
          "name" : "Gris Tráfico",
          "description" : "RAL: 7043",
          "icon": require('../assets/colors/Gris_Trafico.webp'),
          "color": "#484A42",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "negro",
          "name" : "Negro",
          "description" : "SRI: -1.0 SR: 0.04",
          "icon": require('../assets/colors/Negro.webp'),
          "color": "#111111",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "azul",
          "name" : "Azul",
          "description" : "RAL: 5005 SRI: 25 SR: 0.30",
          "icon": require('../assets/colors/Azul.webp'),
          "color": "#001C4F",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "verde",
          "name" : "Verde",
          "description" : "RAL: 6005 SRI: 3 SR: 0.08",
          "icon": require('../assets/colors/Verde.webp'),
          "color": "#00281E",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "rojogranate",
          "name" : "Rojo Granate",
          "description" : "SRI: 34 SR: 0.26",
          "icon": require('../assets/colors/Rojo_Granate.webp'),
          "color": "#641411",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "rojoescarlata",
          "name" : "Rojo Escarlata",
          "description" : "SRI: 36 SR: 0.39",
          "icon": require('../assets/colors/Rojo_Escarlata.webp'),
          "color": "#B10712",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "cafecapuccino",
          "name" : "Café Capuccino",
          "description" : "SRI: 40 SR: 0.4",
          "icon": require('../assets/colors/Cafe_Capuccino.webp'),
          "color": "#B3926F",
          "decal": "gray",
          "active" : true,
          "interactable" : true
        }
      ]
      ,
      "sintraslapo" : 
      [
        {
          "id": "blanco9016",
          "name" : "Blanco 9016",
          "description" : "RAL: 9016 SRI: 85 SR: 0.72",
          "icon": require('../assets/colors/BlancoRAL9016.webp'),
          "color": "#FFFFFF",
          "decal": "gray",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "blanco9002",
          "name" : "Blanco 9002",
          "description" : "RAL: 9002 SRI: 75 SR: 0.65",
          "icon": require('../assets/colors/Blanco_RAL9002.webp'),
          "color": "#E3D9BD",
          "decal": "gray",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "grisglacial",
          "name" : "Gris Glacial",
          "description" : "SRI: 50",
          "icon": require('../assets/colors/Gris_Glacial.webp'),
          "color": "#949494",
          "decal": "gray",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "gristrafico",
          "name" : "Gris Tráfico",
          "description" : "RAL: 7043",
          "icon": require('../assets/colors/Gris_Trafico.webp'),
          "color": "#484A42",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "negro",
          "name" : "Negro",
          "description" : "SRI: -1.0 SR: 0.04",
          "icon": require('../assets/colors/Negro.webp'),
          "color": "#111111",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "azul",
          "name" : "Azul",
          "description" : "RAL: 5005 SRI: 25 SR: 0.30",
          "icon": require('../assets/colors/Azul.webp'),
          "color": "#001C4F",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "verde",
          "name" : "Verde",
          "description" : "RAL: 6005 SRI: 3 SR: 0.08",
          "icon": require('../assets/colors/Verde.webp'),
          "color": "#00281E",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "rojogranate",
          "name" : "Rojo Granate",
          "description" : "SRI: 34 SR: 0.26",
          "icon": require('../assets/colors/Rojo_Granate.webp'),
          "color": "#641411",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "rojoescarlata",
          "name" : "Rojo Escarlata",
          "description" : "SRI: 36 SR: 0.39",
          "icon": require('../assets/colors/Rojo_Escarlata.webp'),
          "color": "#B10712",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "cafecapuccino",
          "name" : "Café Capuccino",
          "description" : "SRI: 40 SR: 0.4",
          "icon": require('../assets/colors/Cafe_Capuccino.webp'),
          "color": "#B3926F",
          "decal": "gray",
          "active" : true,
          "interactable" : true
        }
      ]
      ,
      "canaleta" : 
      [
        {
          "id": "blanco9016",
          "name" : "Blanco 9016",
          "description" : "RAL: 9016 SRI: 85 SR: 0.72",
          "icon": require('../assets/colors/BlancoRAL9016.webp'),
          "color": "#FFFFFF",
          "decal": "gray",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "blanco9002",
          "name" : "Blanco 9002",
          "description" : "RAL: 9002 SRI: 75 SR: 0.65",
          "icon": require('../assets/colors/Blanco_RAL9002.webp'),
          "color": "#E3D9BD",
          "decal": "gray",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "grisglacial",
          "name" : "Gris Glacial",
          "description" : "SRI: 50",
          "icon": require('../assets/colors/Gris_Glacial.webp'),
          "color": "#949494",
          "decal": "gray",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "gristrafico",
          "name" : "Gris Tráfico",
          "description" : "RAL: 7043",
          "icon": require('../assets/colors/Gris_Trafico.webp'),
          "color": "#484A42",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "negro",
          "name" : "Negro",
          "description" : "SRI: -1.0 SR: 0.04",
          "icon": require('../assets/colors/Negro.webp'),
          "color": "#111111",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "azul",
          "name" : "Azul",
          "description" : "RAL: 5005 SRI: 25 SR: 0.30",
          "icon": require('../assets/colors/Azul.webp'),
          "color": "#001C4F",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "verde",
          "name" : "Verde",
          "description" : "RAL: 6005 SRI: 3 SR: 0.08",
          "icon": require('../assets/colors/Verde.webp'),
          "color": "#00281E",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "rojogranate",
          "name" : "Rojo Granate",
          "description" : "SRI: 34 SR: 0.26",
          "icon": require('../assets/colors/Rojo_Granate.webp'),
          "color": "#641411",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "rojoescarlata",
          "name" : "Rojo Escarlata",
          "description" : "SRI: 36 SR: 0.39",
          "icon": require('../assets/colors/Rojo_Escarlata.webp'),
          "color": "#B10712",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "cafecapuccino",
          "name" : "Café Capuccino",
          "description" : "SRI: 40 SR: 0.4",
          "icon": require('../assets/colors/Cafe_Capuccino.webp'),
          "color": "#B3926F",
          "decal": "gray",
          "active" : true,
          "interactable" : true
        }
      ]
      ,
      "metaldeck" : 
      [
        {
          "id": "metalgalvanizado",
          "name" : "Galvanizado",
          "description" : "",
          "icon": require('../assets/colors/Blanco_RAL9002.webp'),
          "color": "#E3D9BD",
          "decal": "blue",
          "active" : true,
          "interactable" : true
        },
        {
          "id": "metalnegro",
          "name" : "Negro",
          "description" : "SRI: -1.0 SR: 0.04",
          "icon": require('../assets/colors/Negro.webp'),
          "color": "#111111",
          "decal": "white",
          "active" : true,
          "interactable" : true
        },
      ]
      ,
    }
  }
}